<div class="route-plan" data-testid="route-plan-container" [hidden]="loadingMap || noRoute">
  @for (routePlanEl of routeData?.RoutePlan; track routePlanEl; let i = $index) {
  <div class="route-element-outer" [attr.data-testid]="'route-plan-item-' + i"
    [class.active]="activePlanningPanelRouteElement==i">

    @if (i!=0) {
    <div class="route-el-divider">
      <div class="divider-line-wrap">
        <div class="divider-line"></div>
      </div>
      <div class="distance-chip">
        <svg class="distance-chip-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 8h12M8 3l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        @if (settingsService.getUnit().Distance == 'metric') {
        <span>{{ (routePlanEl.DistanceFromPreviousElement ?? 0) | turnValueIntegerThousands }} km</span>
        }
        @if (settingsService.getUnit().Distance == 'imperial') {
        <span>{{ (routePlanEl.DistanceFromPreviousElement ?? 0)*0.621371192 | turnValueIntegerThousands }} mi</span>
        }
      </div>
    </div>
    }

    <!-- CARD -->
    <div class="re-card" [class.re-card--charger]="routePlanEl.Type==RoutePlanType.Charger || routePlanEl.Type==RoutePlanType.ChargerEndPoint">

      <!-- LEFT: type icon badge -->
      <div class="re-badge"
        [class.re-badge--start]="routePlanEl.Type==RoutePlanType.StartPoint"
        [class.re-badge--end]="routePlanEl.Type==RoutePlanType.EndPoint"
        [class.re-badge--waypoint]="routePlanEl.Type==RoutePlanType.WayPoint"
        [class.re-badge--charger]="routePlanEl.Type==RoutePlanType.Charger || routePlanEl.Type==RoutePlanType.ChargerEndPoint"
        [class.re-badge--warning]="routePlanEl.BatteryReservedWarning"
        [attr.data-testid]="'route-plan-badge-' + i"
        [attr.tabindex]="routePlanEl.BatteryReservedWarning ? 0 : null"
        (click)="routePlanEl.BatteryReservedWarning ? openBatteryReservedSnackbar() : $event.stopPropagation()"
        (keydown.enter)="routePlanEl.BatteryReservedWarning ? openBatteryReservedSnackbar() : $event.stopPropagation()">

        @if (routePlanEl.Type==RoutePlanType.StartPoint) {
        <!-- Flag / start -->
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 21V4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M5 4h11l-3 4.5 3 4.5H5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="currentColor" fill-opacity="1"/>
        </svg>
        }
        @if (routePlanEl.Type==RoutePlanType.EndPoint) {
        <!-- Checkered flag / target -->
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="10" r="6" stroke="currentColor" stroke-width="2"/>
          <circle cx="12" cy="10" r="2.5" fill="currentColor"/>
          <line x1="12" y1="16" x2="12" y2="22" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        }
        @if (routePlanEl.Type==RoutePlanType.WayPoint) {
        <!-- Waypoint number -->
        <span class="re-badge-number">{{ routePlanEl.WaypointIndex }}</span>
        }
        @if (routePlanEl.Type==RoutePlanType.Charger) {
        <!-- Lightning bolt + number -->
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 2L4.5 13.5H12L11 22L19.5 10.5H12L13 2Z" fill="currentColor" stroke="currentColor" stroke-width="1" stroke-linejoin="round"/>
        </svg>
        <span class="re-badge-charger-index">{{ (routePlanEl.ChargerIndex ?? 0) + 1 }}</span>
        }
        @if (routePlanEl.Type==RoutePlanType.ChargerEndPoint) {
        <!-- Lightning bolt at destination -->
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 2L4.5 13.5H12L11 22L19.5 10.5H12L13 2Z" fill="currentColor" stroke="currentColor" stroke-width="1" stroke-linejoin="round"/>
        </svg>
        <svg class="re-badge-target" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
          <circle class="re-badge-target-bg" cx="6" cy="6" r="6"/>
          <circle class="re-badge-target-ring" cx="6" cy="6" r="4.25"/>
          <circle class="re-badge-target-dot" cx="6" cy="6" r="1.75"/>
        </svg>
        }
      </div>

      <!-- RIGHT: content -->
      <div class="re-content">

        <!-- Weather chip, the last item of the card's last row (charging line, or the battery row on other cards): on the right end when it fits, otherwise on its own line at the bottom right. The SVG is inlined so its strokes follow the theme colour like the clock icon -->
        <ng-template #weatherChip>
          @if (routePlanEl.WeatherImg) {
          <span class="re-weather" aria-hidden="true" data-testid="route-plan-weather-chip">
            <span [appSvgRecolor]="'assets/icons/default/weather/' + routePlanEl.WeatherImg"></span>
          </span>
          }
        </ng-template>

        <!-- Header: name + operator. The <button> selecting the element; its ::before covers the whole card (the badge and the fast-charge info sit above it), so the card stays clickable everywhere without nesting buttons inside a button. -->
        <button type="button" class="re-select ev-plain-button" [attr.data-testid]="'route-plan-item-btn-' + i" (click)="onRoutePlanClick(routePlanEl, i)">
          <span class="re-name">{{ routePlanEl.Name }}</span>
          @if (routePlanEl.OperatorName) {
          <span class="re-operator">{{ routePlanEl.OperatorName }}</span>
          }
        </button>

        <!-- Battery row -->
        <span class="re-battery-row">

          @if (routePlanEl.Type==RoutePlanType.Charger || routePlanEl.Type==RoutePlanType.ChargerEndPoint) {
          <!-- Charger: one battery filled up to the departure level, solid up to the arrival level and a gradient from there (the charge added here), then arrival % → departure % -->
          <span class="re-battery-widget re-battery-widget--charge">
            @let chargeStart = getChargeStartOffset(routePlanEl);
            <svg class="re-bat-icon" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient [attr.id]="batteryGradientId + i">
                  <stop class="re-bat-stop-arrival" offset="0"/>
                  <stop class="re-bat-stop-arrival" [attr.offset]="chargeStart"/>
                  <stop class="re-bat-stop-charged" offset="1"/>
                </linearGradient>
              </defs>
              <rect x="0.75" y="0.75" width="24.5" height="12.5" rx="2.25" stroke="currentColor" stroke-width="1.5"/>
              <path d="M26.5 4.5v5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <rect class="re-bat-fill-charge" x="2" y="2" height="10" [attr.width]="(routePlanEl.BatteryMaxPercent ?? 0) * 0.22" rx="1.25"
                [attr.fill]="'url(#' + batteryGradientId + i + ')'"/>
            </svg>
            <span class="re-bat-pct">{{ routePlanEl.BatteryMinPercent }}%</span>
            <svg class="re-bat-arrow" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 5h12M9 1l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="re-bat-pct">{{ routePlanEl.BatteryMaxPercent }}%</span>
            @if (isFastchargeIcon(routePlanEl.BatteryMaxPercent ?? 0)) {
            <!-- charging past the vehicle's fast-charge limit: explains why -->
            <button type="button" class="re-fastcharge-info ev-plain-button" [attr.data-testid]="'route-plan-fastcharge-info-btn-' + i"
              [attr.aria-label]="languageService.languageJSON?.InfoSidebar_Info_FastChargeLimit"
              (click)="openFastchargeDialog($event)">i</button>
            }
          </span>
          }

          @if (routePlanEl.Type!=RoutePlanType.Charger && routePlanEl.Type!=RoutePlanType.ChargerEndPoint) {
          <!-- Non-charger: single battery level -->
          <span class="re-battery-widget">
            <svg class="re-bat-icon" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.75" y="0.75" width="24.5" height="12.5" rx="2.25" stroke="currentColor" stroke-width="1.5"/>
              <path d="M26.5 4.5v5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <rect class="re-bat-fill" x="2" y="2" height="10" [attr.width]="$any(routePlanEl).BatteryLevel * 0.22" rx="1.25"/>
            </svg>
            <span class="re-bat-pct">{{ $any(routePlanEl).BatteryLevel }}%</span>
          </span>
          <ng-container [ngTemplateOutlet]="weatherChip" />
          }
        </span>

        @if (routePlanEl.Type==RoutePlanType.Charger || routePlanEl.Type==RoutePlanType.ChargerEndPoint) {
        @let chargeTime = getChargeTimeLabel(routePlanEl);
        @let chargeDetails = getChargeDetails(routePlanEl);
        @if (chargeTime || chargeDetails.length || routePlanEl.WeatherImg) {
        <!-- Charging line: time · plug · power (only the parts we have), weather last -->
        <span class="re-charge-meta" [attr.data-testid]="'route-plan-charge-meta-' + i">
          @if (chargeTime) {
          <span class="re-meta-part" [class.re-meta-part--sep]="chargeDetails.length">
            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="6.25" stroke="currentColor" stroke-width="1.5"/>
              <path d="M8 5v3.5l2 1.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ chargeTime }}
          </span>
          }
          @for (detail of chargeDetails; track $index; let last = $last) {
          <span class="re-meta-part" [class.re-meta-part--sep]="!last">{{ detail }}</span>
          }
          <ng-container [ngTemplateOutlet]="weatherChip" />
        </span>
        }
        }

      </div>
    </div>
  </div>
  }
</div>
